<template lang="pug">
.send-message-form
  .contents.d-flex.flex-wrap.align-items-start
    .register-body
      //- error message
      .register-row(v-if="errorMessage != ''")
        .register-group
          span.error-message {{ errorMessage }}
      .register-row
        .register-group
          .register-key
            span.key-name 宛先種別
            span.validation-label 必須
          .register-value
            label.register-radio-label(v-if="_enableUseSendTargetToAllFamily")
              input#type-0.register-radio-form(v-model="type" name="type" type="radio" value=0 v-validate="{ required: true }" data-vv-as="宛先種別")
              span.register-radio-text 家族全員
            label.register-radio-label(v-if="_enableUseSendTargetToFamily")
              input#type-1.register-radio-form(v-model="type" name="type" type="radio" value=1)
              span.register-radio-text 家族個別

            label.register-radio-label(v-if="2 <= planType && _enableUseSendTargetToOtherUser")
              input#type-2.register-radio-form(v-model="type" name="type" type="radio" value=2)
              span.register-radio-text 施設関係者個別
            div(v-show="planType < 2")
              label#disable-type-2.register-radio-label
                span.register-radio-text.disable 施設関係者個別
              b-popover(target="disable-type-2" triggers="hover" placement="top")
                template(v-slot:title) 施設関係者個別
                span 職員等のLINEにメッセージを送ることができます。
                br
                span ※ ベーシックプラン以上で使用可能

            label.register-radio-label(v-if="1 <= planType && ( _enableUseSendTargetToFamilySendMessageGroup || _enableUseSendTargetToOtherUserSendMessageGroup)")
              input#type-3.register-radio-form(v-model="type" name="type" type="radio" value=3)
              span.register-radio-text グループ
            div(v-show="planType < 1")
              label#disable-type-3.register-radio-label
                span.register-radio-text.disable グループ
              b-popover(target="disable-type-3" triggers="hover" placement="top")
                template(v-slot:title) グループ
                span 作成した宛先グループ、利用者グループ、施設関係者グループ宛にメッセージを送ることができます。
                br
                span ※ ライトプラン以上で使用可能
            
          .error-messages(v-if="errors.has('type')")
            div(v-for="error in errors.collect('type')")
              label.error-message {{ error }}
      //- 家族個別の宛先ボタン
      .register-row(v-show="type == 1")
        .register-group
          .register-key
            span.key-name 宛先
            span.validation-label 必須
          .register-value.flex-wrap.send-targets
            .loading(v-if="isBusy")
              b-spinner.spinner
              span 宛先読込中...
            button.btn.send-target-select-btn(v-else @click="showSendTargetSelectModal") 宛先選択
            template(v-for="group in targets")
              template(v-for="resident in group.residents")
                .send-target.d-flex(v-for="family in resident.families" v-if="family.isTarget")
                  span.target-name.align-self-center {{ family.familyName }}{{ getSenderType(family.senderType) }}
                  b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteTarget(family)") X
          .error-messages(v-if="errors.has('message-targets')")
            div(v-for="error in errors.collect('message-targets')")
              label.error-message {{ error }}
      //- 施設関係者個別の宛先ボタン
      .register-row(v-show="type == 2")
        .register-group
          .register-key
            span.key-name 宛先
            span.validation-label 必須
          .register-value.flex-wrap.send-targets
            .loading(v-if="isOtherUserBusy")
              b-spinner.spinner
              span 宛先読込中...
            button.btn.send-target-select-btn(v-else @click="showOtherUserGroupSelectModal") 宛先選択
            template(v-for="target in otherUserTargets")
              .send-target.d-flex(v-for="member in target.members" v-if="member.isTarget")
                span.target-name.align-self-center {{ member.memberName }}{{ getSenderType(member.senderType) }}
                b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteOtherUserGroupTarget(member)") X
          .error-messages(v-if="errors.has('message-other-user-group-member-targets')")
            div(v-for="error in errors.collect('message-other-user-group-member-targets')")
              label.error-message {{ error }}
      //- グループの宛先ボタン
      .register-row(v-show="type == 3")
        .register-group
          .register-key
            span.key-name 宛先
            span.validation-label 必須
          .register-value.flex-wrap.send-targets
            .loading(v-if="isGroupBusy")
              b-spinner.spinner
              span 宛先読込中...
            button.btn.send-target-select-btn(v-else @click="showGroupSelectModal") 宛先選択
            .send-target.d-flex(v-for="group in groupTargets.familyGroups" v-if="group.isTarget")
              span.target-name.align-self-center {{ group.name }}
              b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteGroupTarget(group)") X
            .send-target.d-flex(v-for="group in groupTargets.otherUserGroupMemberGroups" v-if="group.isTarget")
              span.target-name.align-self-center {{ group.name }}
              b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteGroupTarget(group)") X
            .send-target.d-flex(v-for="group in groupTargets.residentGroups" v-if="group.isTarget")
              span.target-name.align-self-center {{ group.name }}
              b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteGroupTarget(group)") X
            .send-target.d-flex(v-for="group in groupTargets.otherUserGroups" v-if="group.isTarget")
              span.target-name.align-self-center {{ group.name }}
              b-badge.delete-btn.align-self-center(variant="secondary" @click="deleteGroupTarget(group)") X
          .error-messages(v-if="errors.has('message-group-targets')")
            div(v-for="error in errors.collect('message-group-targets')")
              label.error-message {{ error }}

      FormInputSelect(v-if="1 <= planType" v-model="templateId" key-name="テンプレート" name="template-id" :options="templateOptions" :styles="{ 'width': '600px' }")
      .register-row(v-show="planType < 1")
        .register-group
          .register-key
            span.key-name テンプレート
          #disable-template.register-value
            select.register-form.input-select.disable(disabled style="width: 600px;")
              option ※ ライトプラン以上で使用可能
          b-popover(target="disable-template" triggers="hover" placement="top")
            template(v-slot:title) テンプレート
            span タイトル、本文、見ましたボタン、既読確認メッセージ、返信ボタンをテンプレートとして保存し、メッセージ作成時に使用することができます。
            br
            span ※ ライトプラン以上で使用可能

      .register-row
        .register-group
          .register-key
            span.key-name タイトル
            span.validation-label 必須
          .register-value
            input#message-title.register-form(
              v-model="title"
              type="text"
              placeholder="タイトル"
              name="message-title"
              v-validate="{ required: true, max: 100 }"
              data-vv-as="タイトル"
              maxlength="100"
              :class="{ noinput: !title }"
            )
          .error-messages(v-if="errors.has('message-title')")
            div(v-for="error in errors.collect('message-title')")
              label.error-message {{ error }}
              br

      .register-row
        .register-group
          .register-key
            .left-side.d-flex
              span.key-name 本文
              span.validation-label 必須
            .right-side
              HelpIcon(popoverId="message-url-help" title="リンクの記載について")
                template(v-slot:text)
                  span メッセージ内でURLリンクを使用したい場合は、改行してURLを記載することでリンクを送ることができます。
                  br
                  span 実際に送られるLINEメッセージは送信ボタン押下時のプレビューをご確認ください。
                  br
                  br
                  strong 記載例
                  br
                  span 以下のリンクからコニカミノルタへアクセスしてください。
                  br
                  span https://www.konicaminolta.com
                  br
                  br
                  strong リンク名を付ける方法
                  br
                  span 以下のようにリンク名とURLを記載すると、リンク名を表示することができます。
                  br
                  span [リンク名](URL)
                  br
                  br
                  strong 記載例（リンク名を付ける方法）
                  br
                  span [HitomeQ](https://konicaminolta.com)
          .register-value 
            textarea#text.register-form(
              v-model="text"
              placeholder="本文"
              name="text"
              v-validate="{ required: true, max: 1000, valid_link_url: true }"
              data-vv-as="本文"
              maxlength="1000"
              rows="7"
              :class="{ noinput: !text }"
            )
          .error-messages(v-if="errors.has('text')")
            div(v-for="error in errors.collect('text')")
              label.error-message {{ error }}
              br
      .checkboxs.d-flex.flex-row.flex-wrap
        FormCheck.option-button.add-read(
          v-model="addReadButton"
          key-name="見ましたボタン"
          name="add-read"
          label="つける"
          @onClick="onAddReadCheck(addReadButton)"
        )
        FormCheck.option-button.option-text(
          v-model="addOptionText"
          key-name="既読確認メッセージ"
          name="option-text"
          label="つける"
          :active="addReadButton"
          :disabled="!addReadButton"
        )
          template(v-slot:question)
            HelpIcon(popoverId="message-set-confirm" title="既読確認メッセージについて")
              template(v-slot:text)
                span チェックをつけることでLINEメッセージの見ましたボタンの強調メッセージを付与します。
                br
                span 実際に送られるLINEメッセージは送信ボタン押下時のプレビューをご確認ください。
                br
                br
                strong 付与されるメッセージ
                br
                span.option-text 「見ました」が押されなかった場合、施設から連絡をさせて頂く場合があります。
        FormCheck.option-button.reply-btn(
          v-model="addReplyButton"
          key-name="返信ボタン"
          name="add-reply-button"
          label="つける"
        )
    .register-body(v-if="1 <= planType")
      .register-row
        .register-group
          .register-key
            .left-side.d-flex
              span.key-name 添付ファイル
              span.comment ※最大9ファイルまで登録可能です
            .right-side
              HelpIcon(popoverId="temp-files-help" :title="'選択可能なファイルについて'")
                template(#text)
                  span 選択可能なファイルは、写真（jpeg）、動画（mp4もしくはmov）、pdfです。
                  br
                  span pdfはそのまま送るか、画像に変換して送るかをファイルごとに選択できます。
                  span 画像に変換した場合は、LINEですぐに見ることができます。
                  br
                  span 送信可能な動画のファイルサイズは200MB未満、pdfは50MB未満です。
                  br
                  span ファイルサイズが大きいと送信に時間がかかりますので、なるべく小さいサイズにしてください。
          .register-value
            .d-flex.flex-column
              MultiFileSelecter(
                ref="fileSelecter"
                :mimetypes="['video/quicktime', 'video/mp4', 'image/jpeg', 'application/pdf']"
                width="450px"
                height="74px"
                :limit="_registerImageFilesLimit"
                :showPreview="true"
                :enablePreviewStatus="_enablePreviewStatus"
                @input="inputFiles"
                @preview="onTempFilePreview"
              )
              label.need-convert-pdf
                input(v-model="needConvertPdf" name="need-convert-pdf" type="checkbox")
                span.text PDFファイルの場合、画像に変換する
              input(name="tempfiles-multiple-register-errors" data-vv-as="添付ファイル" style="display: none")
              .error-messages.text-break(v-for="error in errors.collect('tempfiles-multiple-register-errors')" :style="{ 'maxWidth': '500px' }")
                label.error-message {{ error }}
                br
      .register-row
        DraggableFiles(v-model="files" @delete="onFileDelete" :item-width="'468px'")
    .register-body(v-show="planType < 1")
      .register-row
        .register-group
          .register-key
            .left-side.d-flex
              span.key-name 添付ファイル
          .register-value
            button#disable-file-select-btn.btn.disable(type="button") ファイルを選択
            b-popover(target="disable-file-select-btn" triggers="hover" placement="top")
              template(v-slot:title) 添付ファイル
              span 写真・動画・PDFをメッセージに添付できます。
              br
              span ※ ライトプラン以上で使用可能

  .box-footer.register-footer
    ValidationAlert(v-model="showValidationAlert")
    button.btn.preview-btn(type="button" @click="onMessagePreview") プレビュー

    .buttons.m-0
      button#save-draft-btn.btn(v-if="1 <= planType" type="button" @click="onSaveDraftMessage()" :class="{ 'disable': _disableUseSaveDraftMessage }") 下書き保存
      b-popover(v-if="1 <= planType" target="save-draft-btn" triggers="hover" placement="top")
        template(v-slot:title) 下書き保存ボタン
        span 下書きを保存すると、後で修正・送信できます。
        br
        span 担当者が下書きし、管理者が確認して送信することも出来ます。
      b-popover(v-if="planType < 1" target="save-draft-btn" triggers="hover" placement="top")
        template(v-slot:title) 下書き保存ボタン
        span 下書きを保存すると、後で修正・送信できます。
        br
        span ※ ライトプラン以上で使用可能

      button.btn.send-message-btn(type="button" @click="sendMessageConfirm()"
        :class="{ 'disable': _disableUseSendAndReply }" :disabled="_disableUseSendAndReply") 送信

  SendMessageSelectModal(ref="sendMessageSelectModal" @add="addSendTarget")
  SendMessageOtherUserGroupSelectModal(ref="otherUserGroupSelectModal" @add="addSendOtherUserGroupTarget")
  SendMessageGroupSelectModal(ref="groupSelectModal" :planType="planType" :groupType.sync="groupType" @add="addSendGroupTarget")
  SendMessageFilePreviewModal(ref="previewModal")
  SendMessageModal(ref="messageConfirmModal" :files="files" @preview="onTempFilePreview" @submit="sendMessage")
  OkCancelModal(v-model="showConfirmDraftMessageModal" title="下書きを保存します。よろしいですか？" @ok="saveDraftMessage()")

  PageLoading(:isBusy="isLoading" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Watch, Inject, Vue } from "vue-property-decorator";
import draggable from "vuedraggable";
import { userStore, screenInputTemporaryStore } from "@/store/store";
import { needRefreshesStore } from "@/store/store";
import { PcUrl } from "@/commons/constants/PcUrl";

import CustomValidate from "@/commons/utils/CustomValidate";
import Setting from "../../../../public/setting.json";
import FamiliesService, { FamilyGetModel } from "@/commons/services/Families";
import { SenderType } from "@/commons/models/Resident";
import OtherUserGroupsService from "@/commons/services/OtherUserGroups";
import OtherUserGroupMembersService from "@/commons/services/OtherUserGroupMembers";
import OtherUserGroupTypeMembersService, { OtherUserGroupTypeGroup, OtherUserGroupTypeMember } from "@/commons/services/OtherUserGroupTypeMembers";
import OtherUserGroupTypesService from "@/commons/services/OtherUserGroupTypes";
import OtherUserGroupTypeModel from "@/commons/models/OtherUserGroupType";
import { SendMessageTargetGroup, SendMessageTargetResident, SendTargetFamily } from "@/commons/models/SendMessageTarget";
import { SendMessageFunction } from "@/commons/models/Message";
import SendMessageFormCommonService from "@/commons/services/SendMessageFormCommon";
import SendMessageGroupMembersService, {
  SendMessageGroupMembersFamilyGetModel,
  SendMessageGroupMembersOtherUserGroupMemberGetModel
} from "@/commons/services/SendMessageGroupMembers";
import SendMessageGroupsService, { SendMessageGroupsGetModel } from "@/commons/services/SendMessageGroups";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import { PlanType } from "@/commons/services/Plans";
import { DraftMessageFile, DraftMessagesGetModel, DraftMessagesPatchModel, DraftMessagesPostModel } from "@/commons/services/DraftMessages";
import S3UrlService from "@/commons/services/S3Url";
import SendMessageTemplatesService, { SendMessageTemplatesGetModel, TemplateType } from "@/commons/services/SendMessageTemplates";
import SystemError from "@/commons/models/SystemError";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import MultiFileSelecter from "@/pc/basics/MultiFileSelecter.vue";
import FormCheck from "@/pc/components/forms/FormCheck.vue";
import DraggableFiles, { ExtDraggableFile } from "@/pc/components/ExtDraggableFiles.vue";
import SendMessageSelectModal from "@/pc/components/modals/SendMessageSelectModal.vue";
import SendMessageOtherUserGroupSelectModal from "@/pc/components/modals/SendMessageOtherUserGroupSelectModal.vue";
import SendMessageGroupSelectModal, { GroupType } from "@/pc/components/modals/SendMessageGroupSelectModal.vue";
import SendMessageModal from "@/pc/components/modals/SendMessageModal.vue";
import SendMessageFilePreviewModal from "@/pc/components/modals/SendMessageFilePreviewModal.vue";
import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";
import Loading from "@/pc/basics/Loading.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import { SendMailMessagesPostModel } from "@/commons/services/SendMailMessages";
import { SendLineMessagesPostModel } from "@/commons/services/SendLineMessages";
import { LineReceiverDetail } from "@/commons/models/SendLineMessage";
import OtherUserGroup from "@/commons/models/OtherUserGroup";

/**
 * メッセージ送信フォームコンポーネント
 */
@Component({
  components: {
    draggable,
    SendMessageSelectModal,
    SendMessageOtherUserGroupSelectModal,
    SendMessageGroupSelectModal,
    SendMessageModal,
    FormCheck,
    MultiFileSelecter,
    DraggableFiles,
    SendMessageFilePreviewModal,
    HelpIcon,
    FormInputSelect,
    Loading,
    OkCancelModal,
    PageLoading,
    ValidationAlert
  },
  $_veeValidate: { validator: "new" }
})
export default class SendMessageForm extends Vue {
  /** 家族サービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;
  /** 施設関係者グループサービス */
  @Inject("OtherUserGroupsService") otherUserGroupsService!: OtherUserGroupsService;
  /** 施設関係者グループメンバー取得サービス */
  @Inject("OtherUserGroupMembersService") otherUserGroupMembersService!: OtherUserGroupMembersService;
  /** 施設関係者グループ種類にひもづくメンバー取得サービス */
  @Inject("OtherUserGroupTypeMembersService") otherUserGroupTypeMembersService!: OtherUserGroupTypeMembersService;
  /** 施設関係者グループ種類サービス */
  @Inject("OtherUserGroupTypesService") otherUserGroupTypesService!: OtherUserGroupTypesService;
  /** 宛先グループサービス */
  @Inject("SendMessageGroupsService") sendMessageGroupsService!: SendMessageGroupsService;
  /** 宛先グループメンバーサービス */
  @Inject("SendMessageGroupMembersService") sendMessageGroupMembersService!: SendMessageGroupMembersService;
  /** メッセージ送信テンプレートサービス */
  @Inject("SendMessageTemplatesService") sendMessageTemplatesService!: SendMessageTemplatesService;
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;

  /** ページ全体ローディング表示可否 */
  isLoading: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 下書き保存確認モーダル表示可否 */
  showConfirmDraftMessageModal: boolean = false;
  /** エラーメッセージ */
  errorMessage: string = "";

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** プラン種別 */
  planType: PlanType = PlanType.UNKNOWN;

  /** 宛先種別 */
  type: string = "";
  /** 宛先(家族) */
  targets: Array<SendMessageTargetGroup> = [];
  /** 宛先読込み中 */
  isBusy: boolean = true;
  /** 宛先(施設関係者) */
  otherUserTargets: Array<OtherUserGroupTypeGroup> = [];
  /** 宛先読込み中(施設関係者) */
  isOtherUserBusy: boolean = true;
  /** 宛先(グループ) */
  groupTargets: GroupModel = { familyGroups: [], otherUserGroupMemberGroups: [], residentGroups: [], otherUserGroups: [] };
  /** 宛先グループの種別（宛先グループや利用者グループなど） */
  groupType: GroupType = GroupType.UNKNOWN;
  /** 宛先読込み中(グループ) */
  isGroupBusy: boolean = true;
  /** 家族全員に送信で使用する、利用者グループフィルタされていない全家族 */
  allFamily: Array<FamilyGetModel> = [];
  /** 施設関係者メンバー */
  otherUserGroupMembersInFacility: Array<OtherUserGroup> = [];

  /** 使用するメッセージ送信テンプレート */
  templateId: number = 0;
  /** メッセージ送信テンプレート選択肢 */
  templateOptions: Array<{ value: number; label: string }> = [];
  /** メッセージ送信テンプレートMAP */
  templateIdMap: Map<number, SendMessageTemplatesGetModel> = new Map();

  /** 送信メッセージタイトル */
  title: string = "";
  /** 送信メッセージ本文 */
  text: string = "";
  /** メッセージの返信が欲しいことを強調させるか */
  addOptionText: boolean = false;
  /** 見ましたをつけるか */
  addReadButton: boolean = false;
  /** 返信をつけるか */
  addReplyButton: boolean = false;
  /** 実際に登録するファイル */
  files: Array<ExtDraggableFile> = [];
  /** メッセージ下書きID。メッセージ下書きの「編集」で復元をした場合のみ値が格納される */
  draftMessageId: number | null = null;
  /** メッセージ下書き旧添付ファイル。メッセージ下書きの「編集」で復元をした場合のみ値が格納される */
  draftMessageOldFiles: Array<DraftMessageFile> | null = null;
  /** メッセージ下書き更新日時。メッセージ下書きの「編集」で復元をした場合のみ値が格納される */
  draftMessageUpdated: number | null = null;

  /** 添付ファイルのPDFを変換するか否か */
  needConvertPdf: boolean = false;

  /** ファイル登録数 */
  readonly registerFileUploadLimit: number = 9;

  get _enableUseSendTargetToAllFamily(): boolean {
    return userStore.loginUser.permissions.sendMessagesFunction.useSendTargetToAllFamily;
  }

  get _enableUseSendTargetToFamily(): boolean {
    return userStore.loginUser.permissions.sendMessagesFunction.useSendTargetToFamily;
  }

  get _enableUseSendTargetToOtherUser(): boolean {
    return userStore.loginUser.permissions.sendMessagesFunction.useSendTargetToOtherUser;
  }

  get _enableUseSendTargetToFamilySendMessageGroup(): boolean {
    return userStore.loginUser.permissions.sendMessagesFunction.useSendTargetToFamilySendMessageGroup;
  }

  get _enableUseSendTargetToOtherUserSendMessageGroup(): boolean {
    return userStore.loginUser.permissions.sendMessagesFunction.useSendTargetToOtherUserSendMessageGroup;
  }

  get _disableUseSaveDraftMessage(): boolean {
    return !userStore.loginUser.permissions.sendMessagesFunction.useSaveDraftMessage;
  }

  get _disableUseSendAndReply(): boolean {
    return (
      // メッセージ送信の権限
      !userStore.loginUser.permissions.sendMessagesFunction.useSendAndReply ||
      // 宛先種別radioの各権限
      (!this._enableUseSendTargetToAllFamily &&
        !this._enableUseSendTargetToFamily &&
        (this.planType < 2 || !this._enableUseSendTargetToOtherUser) &&
        (this.planType < 1 || (!this._enableUseSendTargetToFamilySendMessageGroup && !this._enableUseSendTargetToOtherUserSendMessageGroup)))
    );
  }

  @Watch("needConvertPdf")
  public changeNeedConvertPdf(needConvertPdf: boolean): void {
    this.setCookie(needConvertPdf);
    return;
  }

  @Watch("templateId")
  public changeTemplateId(newTemplateId: number): void {
    if (newTemplateId == 0) {
      this.title = "";
      this.text = "";
      this.addOptionText = false;
      this.addReadButton = false;
      this.addReplyButton = false;
    }

    const selectedTemplate: SendMessageTemplatesGetModel | undefined = this.templateIdMap.get(newTemplateId);
    if (selectedTemplate == undefined) {
      return;
    }

    this.title = selectedTemplate.title ? selectedTemplate.title : "";
    this.text = selectedTemplate.text ? selectedTemplate.text : "";
    this.addOptionText = selectedTemplate.addOptionText;
    this.addReadButton = selectedTemplate.addReadButton;
    this.addReplyButton = selectedTemplate.addReplyButton;

    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  public setCookie(needConvertPdf: boolean): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `send-message-form-need-convert-pdf=${needConvertPdf}; max-age=${saveSecond};`;
    return;
  }

  /** ### ファイルをリセットする */
  public resetFiles(): void {
    this.files = [];
    return;
  }

  /**
   * vue lifecycle created
   */
  public created() {
    CustomValidate.addCustomValidate(this.$validator);
    return;
  }

  /**
   *  vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    this.planType = userStore.facility.planType;

    const needConvertPdf: boolean | null = this.loadCookie();
    this.needConvertPdf = needConvertPdf != null ? needConvertPdf : false;

    await this.initialize();

    this.restoreScreenInputTemporaryStore();

    return;
  }

  public async initialize(): Promise<void> {
    this.isLoading = true;
    this.loadingMessage = "読込み中...";

    this.initializeForm();
    await this.initilizeTemplate();
    await this.createView();

    this.isLoading = false;

    return;
  }

  public initializeForm(): void {
    // input要素の内容を初期化
    this.type = "";
    this.title = "";
    this.text = "";
    this.files = [];
    this.templateId = 0;
    this.addOptionText = false;
    this.addReadButton = false;
    this.addReplyButton = false;
    this.draftMessageId = null;
    this.draftMessageOldFiles = null;
    this.draftMessageUpdated = null;

    for (const group of this.targets) {
      for (const resident of group.residents) {
        for (const family of resident.families) {
          family.isTarget = false;
        }
      }
    }

    for (const group of this.otherUserTargets) {
      for (const member of group.members) {
        member.isTarget = false;
      }
    }

    for (const group of this.groupTargets.familyGroups) {
      group.isTarget = false;
    }
    for (const group of this.groupTargets.otherUserGroupMemberGroups) {
      group.isTarget = false;
    }

    for (const group of this.groupTargets.residentGroups) {
      group.isTarget = false;
    }
    for (const group of this.groupTargets.otherUserGroups) {
      group.isTarget = false;
    }

    return;
  }

  public async initilizeTemplate(): Promise<void> {
    // メッセージ送信テンプレートを取得して選択肢、MAPを作成する
    const sendMessageTemplates: Array<SendMessageTemplatesGetModel> = await this.getSendMessageTemplates();
    const templateOptions: Array<{ value: number; label: string }> = this.createTemplateOpstions(sendMessageTemplates);
    this.templateOptions = templateOptions;
    const templateIdMap: Map<number, SendMessageTemplatesGetModel> = this.createTemplateIdMap(sendMessageTemplates);
    this.templateIdMap = templateIdMap;
    return;
  }

  /**
   * ### Cookieを見て、値が保持されている場合はCookieの値を返す
   */
  public loadCookie(): boolean | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      // cookieに値が格納されていないとundefinedが格納されているが、実際にはゴミデータが格納されているので文字列チェックが必要
      const needConvertPdf: string = cookieMap["send-message-form-need-convert-pdf"];

      if (needConvertPdf == "true") {
        return true;
      } else if (needConvertPdf == "false") {
        return false;
      } else {
        return null;
      }
    }

    return null;
  }

  /**
   * ### メッセージ送信テンプレートを取得する
   */
  public async getSendMessageTemplates(): Promise<Array<SendMessageTemplatesGetModel>> {
    const results: Array<SendMessageTemplatesGetModel> = await this.sendMessageTemplatesService.gets(userStore);
    return results;
  }

  /**
   * ### メッセージ送信テンプレートの選択肢を作成する
   */
  public createTemplateOpstions(templates: Array<SendMessageTemplatesGetModel>): Array<{ value: number; label: string }> {
    const options: Array<{ value: number; label: string }> = [];
    options.push({ value: 0, label: `使用しない` });
    for (const template of templates) {
      if (template.templateType == TemplateType.MESSAGE) {
        options.push({ value: template.id, label: template.name });
      }
    }
    return options;
  }

  /**
   * ### テンプレートIDのMAPを作成する
   */
  public createTemplateIdMap(templates: Array<SendMessageTemplatesGetModel>): Map<number, SendMessageTemplatesGetModel> {
    const map: Map<number, SendMessageTemplatesGetModel> = new Map<number, SendMessageTemplatesGetModel>();
    for (const template of templates) {
      map.set(template.id, template);
    }
    return map;
  }

  /**
   * ### 画面表示情報を作成する
   *
   * - エラーメッセージの初期化
   * - 家族宛先の作成
   * - 施設関係者宛先の作成
   * - 宛先グループ宛先の作成
   */
  public async createView(): Promise<void> {
    this.errorMessage = "";

    this.isBusy = true;
    this.isOtherUserBusy = true;
    this.isGroupBusy = true;

    const residentGroups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    const targets: Array<SendMessageTargetGroup> = await this.createTargets(residentGroups);
    this.targets = targets;
    const allFamily: Array<FamilyGetModel> = await this.getNonmaskedFamilies();
    this.allFamily = allFamily;
    this.isBusy = false;

    const otherUserTargets: Array<OtherUserGroupTypeGroup> = await this.createOtherUserTargets();
    this.otherUserTargets = otherUserTargets;
    this.isOtherUserBusy = false;

    const sendMessageGroups: Array<SendMessageGroupsGetModel> = await this.sendMessageGroupsService.gets(userStore);
    const otherUserGroups: Array<OtherUserGroup> = await this.otherUserGroupsService.gets(userStore);
    const otherUserGroupMembersInFacility: Array<OtherUserGroup> = await this.otherUserGroupMembersService.get(userStore);
    this.otherUserGroupMembersInFacility = otherUserGroupMembersInFacility;
    const groupTargets: GroupModel = await this.createGroupTargets(sendMessageGroups, residentGroups, allFamily, otherUserGroups, otherUserGroupMembersInFacility);
    this.groupTargets = groupTargets;
    this.isGroupBusy = false;

    return;
  }

  /**
   * ### 宛先対象リストを作成する
   *
   * 利用者-家族でネストして画面表示するため、構成を合わせる
   * APIから家族を取得すると、家族にひもづく利用者の情報もついてくるので、家族を取得するだけで情報は作れる
   */
  public async createTargets(residentGroups: Array<ResidentGroupsGetModel>): Promise<Array<SendMessageTargetGroup>> {
    // 宛先対象の元となる家族を取得する
    // 0件なら宛先対象は空配列を返す
    const families: Array<FamilyGetModel> = await this.getMaskedFamilies();
    if (families.length == 0) {
      return [];
    }

    let targetResidents: Array<SendMessageTargetResident> = [];
    let residentId: number = families[0].id ? families[0].id : -1;
    let targetResident: SendMessageTargetResident = this.createTargetResident(families[0]);

    for (let i = 1; i < families.length; i++) {
      const family: FamilyGetModel = families[i];

      // 利用者が変わったら新しい利用者を作って、ひもづく家族を追加する
      if (residentId != family.id) {
        targetResidents.push(targetResident);
        targetResident = this.createTargetResident(family);
        residentId = family.id;
      }
      // 利用者が変わらなければ利用者に家族を追加する
      else {
        const targetFamily = this.createTargetFamily(family);
        targetResident.families.push(targetFamily);
      }
    }
    // 最終の利用者を追加する
    targetResidents.push(targetResident);

    // モーダルに表示するのは利用者グループ－利用者－家族の階層構造なので利用者グループに利用者をひもづける
    let targets: Array<SendMessageTargetGroup> = [];
    for (const group of residentGroups) {
      let residents: Array<SendMessageTargetResident> = [];
      for (const resident of targetResidents) {
        if (resident.groupId == group.id) {
          residents.push(resident);
        }
      }
      targets.push({
        id: group.id,
        name: group.name,
        show: true,
        residents: residents
      });
    }

    return targets;
  }

  /**
   * ### 宛先で選択候補とする家族を取得する
   */
  public async getMaskedFamilies(): Promise<Array<FamilyGetModel>> {
    let response: Array<FamilyGetModel> = [];

    try {
      response = await this.familiesService.getsInFacility(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.familiesService.getCountInFacility(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: any = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount
          };
          response = response.concat(await this.familiesService.getsInFacility(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 送信対象の利用者を作成する
   */
  public createTargetResident(family: FamilyGetModel): SendMessageTargetResident {
    let target: SendMessageTargetResident = {
      id: family.id,
      birthday: family.birthday,
      facilityId: family.facilityId,
      gender: family.gender,
      password: family.password,
      name: family.name,
      kanaName: family.kanaName,
      tel: family.tel,
      room: family.room,
      groupId: family.groupId,
      show: true,
      families: []
    };
    target.families.push(this.createTargetFamily(family));

    return target;
  }

  /**
   * ### 送信対象の家族を作成する
   */
  public createTargetFamily(family: FamilyGetModel): SendTargetFamily {
    let target: SendTargetFamily = {
      residentsSortKey: family.residentsSortKey,
      familyId: family.familyId ? family.familyId : 0,
      familyName: family.familyName ? family.familyName : "",
      familyTel: family.familyTel ? family.familyTel : "",
      familyLineId: family.familyLineId ? family.familyLineId : "",
      familyBirthDay: family.familyBirthDay ? family.familyBirthDay : 0,
      familyGender: family.familyGender ? family.familyGender : "",
      familyRelation: family.familyRelation ? family.familyRelation : "",
      familyPosition: family.familyPosition ? family.familyPosition : "",
      familyMailaddress: family.familyMailaddress ? family.familyMailaddress : "",
      senderType: family.senderType,
      show: true,
      isTarget: false
    };

    return target;
  }

  /**
   * ### 利用者グループを取得する
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const response: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### 宛先で選択候補とする家族を取得する
   */
  public async getNonmaskedFamilies(): Promise<Array<FamilyGetModel>> {
    let response: Array<FamilyGetModel> = [];

    try {
      const params: any = {
        masking: "none"
      };
      response = await this.familiesService.getsInFacility(userStore, params);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.familiesService.getCountInFacility(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: any = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount,
            masking: "none"
          };
          response = response.concat(await this.familiesService.getsInFacility(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 宛先対象リストを作成する
   *
   * グループ-メンバーでネストして画面表示するため、構成を合わせる
   */
  public async createOtherUserTargets(): Promise<Array<OtherUserGroupTypeGroup>> {
    // 宛先対象の元となる家族を取得する
    // 0件なら宛先対象は空配列を返す
    const groups: Array<OtherUserGroupTypeGroup> = await this.getOtherUserGroupMembers();
    if (groups.length == 0) {
      return [];
    }

    // グループ種類名を格納する
    const otherUserGroupTypes: Array<OtherUserGroupTypeModel> = await this.getOtherGroupTypes();
    const otherUserGroupTypesMap: Map<number, string> = this.createOtherUserGroupTypesMap(otherUserGroupTypes);
    for (const group of groups) {
      const groupTypeName: string | undefined = otherUserGroupTypesMap.get(group.groupTypeId);
      group.groupName = groupTypeName ? groupTypeName : "";
      group.show = true;
    }

    return groups;
  }

  /**
   * ### グループ-メンバーを取得する
   */
  public async getOtherUserGroupMembers(): Promise<Array<OtherUserGroupTypeGroup>> {
    const targets: Array<OtherUserGroupTypeGroup> = await this.otherUserGroupTypeMembersService.get(userStore, -1);
    for (let target of targets) {
      for (let member of target.members as Array<OtherUserGroupTypeMember>) {
        member.isTarget = false;
        member.show = true;
      }
    }
    return targets;
  }

  /**
   * ### 施設関係者グループ種類を取得する
   */
  public async getOtherGroupTypes(): Promise<Array<OtherUserGroupTypeModel>> {
    const otherUserGroupTypes: Array<OtherUserGroupTypeModel> = await this.otherUserGroupTypesService.get(userStore);
    return otherUserGroupTypes;
  }

  /**
   * ### 画面表示用に施設関係者グループ種類のMAPを作成する
   */
  public createOtherUserGroupTypesMap(otherUserGroupTypes: Array<OtherUserGroupTypeModel>): Map<number, string> {
    const map: Map<number, string> = new Map<number, string>();
    for (const type of otherUserGroupTypes) {
      map.set(type.id, type.name);
    }
    return map;
  }

  /**
   * ### 宛先グループの選択ダイアログ情報を作成する
   */
  public async createGroupTargets(
    sendMessageGroups: Array<SendMessageGroupsGetModel>,
    residentGroups: Array<ResidentGroupsGetModel>,
    allFamily: Array<FamilyGetModel>,
    otherUserGroups: Array<OtherUserGroup>,
    otherUserGroupMembersInFacility: Array<OtherUserGroup>
  ): Promise<GroupModel> {
    const sendMessageGroupModel: GroupModel = {
      familyGroups: [],
      otherUserGroupMemberGroups: [],
      residentGroups: [],
      otherUserGroups: []
    };
    // 宛先グループの情報作成
    for (const group of sendMessageGroups) {
      const _group: SendMessageGroupTargetModel = Object.assign({}, group) as SendMessageGroupTargetModel;
      _group.isTarget = false;
      _group.memberCount = group.members.length;
      if (_group.type == GroupType.FAMILY) {
        sendMessageGroupModel.familyGroups.push({
          ..._group,
          show: true
        });
      } else if (_group.type == GroupType.OTHER_USER) {
        sendMessageGroupModel.otherUserGroupMemberGroups.push({
          ..._group,
          show: true
        });
      }
    }
    // 利用者グループの情報を作成
    // 利用者グループは人数をTBLに持っていないので、MAPを作って集計する
    const residentGroupMemberCountMap = new Map<number, number>();
    for (const family of allFamily) {
      let memberCount: number | undefined = residentGroupMemberCountMap.get(family.groupId);
      if (memberCount) {
        memberCount++;
        residentGroupMemberCountMap.set(family.groupId, memberCount);
      } else {
        residentGroupMemberCountMap.set(family.groupId, 1);
      }
    }
    for (const group of residentGroups) {
      const _group: ResidentGroupTargetModel = Object.assign({}, group) as ResidentGroupTargetModel;
      _group.isTarget = false;
      const memberCount: number | undefined = residentGroupMemberCountMap.get(_group.id);
      _group.memberCount = memberCount ? memberCount : 0;
      sendMessageGroupModel.residentGroups.push({
        ..._group,
        key: `residentGroup_${_group.id}`,
        show: true
      });
    }
    // 施設関係者グループの情報を作成
    // 施設関係者グループは人数をTBLに持っていないので、MAPを作って集計する
    const otherUserGroupMemberCountMap = new Map<number, number>();
    for (const member of otherUserGroupMembersInFacility) {
      let memberCount: number | undefined = otherUserGroupMemberCountMap.get(member.id);
      if (memberCount) {
        memberCount++;
        otherUserGroupMemberCountMap.set(member.id, memberCount);
      } else {
        otherUserGroupMemberCountMap.set(member.id, 1);
      }
    }
    for (const group of otherUserGroups) {
      const _group: OtherUserGroupTargetModel = Object.assign({}, group) as OtherUserGroupTargetModel;
      _group.isTarget = false;
      const memberCount: number | undefined = otherUserGroupMemberCountMap.get(_group.id);
      _group.memberCount = memberCount ? memberCount : 0;
      sendMessageGroupModel.otherUserGroups.push({
        ..._group,
        key: `otherUserGroup_${_group.id}`,
        show: true
      });
    }

    return sendMessageGroupModel;
  }

  /**
   * ### 画面の作り直し
   */
  public async refresh(): Promise<void> {
    await this.initialize();
    return;
  }

  /**
   * ### 画面の作り直し
   */
  public async refreshByNoLoading(): Promise<void> {
    try {
      await this.initializeForm();
    } catch (error) {
      // 処理中に画面遷移が発生した場合、エラーと見なさないためURLチェックする
      if (this.$route.fullPath != PcUrl.SendMessage) {
        return;
      } else {
        throw error;
      }
    }
    return;
  }

  /**
   * ### エラーメッセージを設定する
   *
   * - 親コンポーネントで登録処理をしてエラーが発生した場合に呼び出される
   */
  public setErrorMessage(message: string): void {
    this.errorMessage = message;
    return;
  }

  /**
   * ### 子コンポーネントでファイルが選択された場合のイベント処理
   *
   * - ファイルが上限数以上なら無視する
   * - バリデーションを行う
   * - バリデーションエラーでなければ、ファイルを親コンポーネントに渡す
   */
  public async inputFiles(files: Array<File>): Promise<void> {
    this.isLoading = true;
    this.loadingMessage = "読込み中...";

    const sendMessageFormCommonService: SendMessageFormCommonService = new SendMessageFormCommonService(this.$validator, "tempfiles-multiple-register-errors");
    const addFiles: Array<ExtDraggableFile> = await sendMessageFormCommonService.createAddFile(files, this.registerFileUploadLimit, this.files.length, this.needConvertPdf);

    this.isLoading = false;

    if (0 < addFiles.length) {
      this.files = this.files.concat(addFiles);

      for (let i = 0; i < this.files.length; i++) {
        this.files[i].key = i.toString();
      }
    }

    return;
  }

  /**
   * ### 指定されたファイルを削除する
   */
  public onFileDelete(index: number): void {
    this.files.splice(index, 1);
    return;
  }

  /**
   * ### 添付ファイルプレビューボタン押下イベント処理
   *
   * - ダイアログで添付ファイルをプレビュー表示する
   */
  public async onTempFilePreview(): Promise<void> {
    // ファイルを取得していないものがあったら取得する
    const files = [];
    for (const file of this.files) {
      this.isLoading = true;
      this.loadingMessage = "読込み中...";

      if (!file.fileObject) {
        file.fileObject = await this.getS3File(file.url as string, file.name);
        files.push(file.fileObject);
      } else {
        files.push(file.fileObject);
      }

      this.isLoading = false;
    }

    const modal: SendMessageFilePreviewModal | Vue | Element | Vue[] | Element[] = this.$refs.previewModal;
    if (modal instanceof SendMessageFilePreviewModal) {
      modal.show("", false, files);
    }

    return;
  }

  /**
   * ### メッセージ送信プレビュー
   */
  public async onMessagePreview(): Promise<void> {
    this.isLoading = true;
    this.loadingMessage = "読込み中...";

    const messageConfirmModal: SendMessageModal | Vue | Element | Vue[] | Element[] = this.$refs.messageConfirmModal;
    if (messageConfirmModal instanceof SendMessageModal) {
      const receivers: Array<LineReceiverDetail> = this.createMessagePreviewReceivers();
      const functionContents: SendMessageFunction = this.createMessagePreviewContents();
      messageConfirmModal.show(receivers, functionContents, false, false);
    }

    this.isLoading = false;

    return;
  }

  /**
   * ### 下書き保存の確認モーダルを表示する
   */
  public onSaveDraftMessage(): void {
    // ボタンhoverでpopoverを表示したいため、disabledを付与していない
    // そのためここでclickイベントを無効にしている
    if (this._disableUseSaveDraftMessage) {
      return;
    }

    this.$validator.errors.remove("type");
    this.$validator.errors.remove("message-targets");
    this.$validator.errors.remove("message-other-user-group-member-targets");
    this.$validator.errors.remove("message-group-targets");
    this.$validator.errors.remove("message-title");
    this.$validator.errors.remove("text");
    if (!this.type) {
      this.$validator.errors.add({ field: "type", msg: "下書き保存の場合、宛先は必須項目です" });
      return;
    }

    this.showConfirmDraftMessageModal = true;

    return;
  }

  /**
   * ### 下書きを保存する
   */
  public saveDraftMessage(): void {
    const targets: string[] = this.createDraftMessagesTargets();

    this.setScreenInputTemporaryStore();
    const postModel: DraftMessagesPostModel = {
      type: this.type != "" ? Number(this.type) : undefined,
      targets: targets,
      title: this.title,
      content: this.text,
      addOptionText: this.addOptionText,
      addReadButton: this.addReadButton,
      addReplyButton: this.addReplyButton,
      files: []
    };

    if (this.draftMessageId == null) {
      this.$emit("saveDraftMessage", { draftMessagesModel: postModel, files: this.files, draftMessageId: this.draftMessageId });
    } else {
      let patchModel: DraftMessagesPatchModel = { ...postModel };
      patchModel.oldFiles = this.draftMessageOldFiles != null ? this.draftMessageOldFiles : undefined;
      patchModel.updated = this.draftMessageUpdated != null ? this.draftMessageUpdated : 0;
      this.$emit("saveDraftMessage", { draftMessagesModel: patchModel, files: this.files, draftMessageId: this.draftMessageId });
    }

    return;
  }

  /**
   * ### メッセージ下書きの宛先を作成する
   *
   * - 宛先種別に応じて宛先は可変になる
   *   - 家族全員の場合は空配列
   *   - 家族個別の場合は家族を特定するソートキー
   *   - 施設関係者グループの場合は施設関係者グループを特定するソートキー
   *   - 宛先グループの場合は宛先グループを特定するソートキー
   */
  public createDraftMessagesTargets(): string[] {
    const targets: string[] = [];
    switch (this.type) {
      // 家族全員
      case "0": {
        break;
      }
      // 家族個別
      case "1": {
        for (const targetGroup of this.targets) {
          for (const targetResident of targetGroup.residents) {
            for (let targetFamily of targetResident.families) {
              if (targetFamily.isTarget) {
                targets.push(targetFamily.residentsSortKey);
              }
            }
          }
        }
        break;
      }
      // 施設関係者グループ
      case "2": {
        for (let group of this.otherUserTargets) {
          for (let member of group.members) {
            if (member.isTarget) {
              targets.push(member.otherUserGroupsSortKey);
            }
          }
        }
        break;
      }
      // 宛先グループ
      case "3": {
        for (let group of this.groupTargets.familyGroups) {
          if (group.isTarget) {
            targets.push(group.sendMessageGroupsSortKey);
          }
        }
        for (let group of this.groupTargets.otherUserGroupMemberGroups) {
          if (group.isTarget) {
            targets.push(group.sendMessageGroupsSortKey);
          }
        }
        for (let group of this.groupTargets.residentGroups) {
          if (group.isTarget) {
            targets.push(group.key);
          }
        }
        for (let group of this.groupTargets.otherUserGroups) {
          if (group.isTarget) {
            targets.push(group.key);
          }
        }
        break;
      }
    }
    return targets;
  }

  /**
   * ### メッセージ下書きの内容を復元する
   *
   * - input要素の内容を初期化する
   * - 宛先を復元する
   * - 復元した宛先に欠損がある場合はメッセージを表示する
   */
  public async restoreDraftMessage(draftMessage: DraftMessagesGetModel): Promise<void> {
    // async処理でPromiseメソッドを実行しないと画面表示が崩れるので空のPromiseメソッドを実行する
    await this.emptyProsess();

    this.isLoading = true;
    this.loadingMessage = "読込み中...";
    this.errorMessage = "";

    this.type = draftMessage.type != undefined ? `${draftMessage.type}` : "";
    this.title = draftMessage.title != undefined ? `${draftMessage.title}` : "";
    this.text = draftMessage.content != undefined ? `${draftMessage.content}` : "";
    this.files = [];
    this.addOptionText = draftMessage.addOptionText != undefined ? draftMessage.addOptionText : false;
    this.addReadButton = draftMessage.addReadButton != undefined ? draftMessage.addReadButton : false;
    this.addReplyButton = draftMessage.addReplyButton != undefined ? draftMessage.addReplyButton : false;
    this.draftMessageId = draftMessage.id;
    this.draftMessageOldFiles = draftMessage.files != undefined ? draftMessage.files : null;
    this.draftMessageUpdated = draftMessage.updated;

    if (this.type != "") {
      if (draftMessage.targets != undefined && 0 < draftMessage.targets.length) {
        let restoredCount: number = 0;

        switch (this.type) {
          // 家族個別
          case "1": {
            let map: Map<string, string> = new Map<string, string>();
            for (const targetSortKey of draftMessage.targets) {
              map.set(targetSortKey, targetSortKey);
            }
            restoredCount = this.restoreFamilyTargets(map);
            break;
          }
          // 施設関係者個別
          case "2": {
            let map: Map<string, string> = new Map<string, string>();
            for (const targetSortKey of draftMessage.targets) {
              map.set(targetSortKey, targetSortKey);
            }
            restoredCount = this.restoreOtherUserMemberTargets(map);
            break;
          }
          // 宛先グループ
          // 宛先グループの場合は宛先だけではなく、種別（groupType）も復元する
          case "3": {
            const map: Map<string, string> = new Map<string, string>();
            for (const targetSortKey of draftMessage.targets) {
              map.set(targetSortKey, targetSortKey);
            }
            restoredCount = this.restoreSendMessageGroupTargetsAndGroupType(map);
            break;
          }
          default: {
            break;
          }
        }

        if (restoredCount == 0) {
          this.errorMessage = "宛先が削除されています";
        } else if (restoredCount != draftMessage.targets.length) {
          this.errorMessage = "宛先が一部削除されています";
        }
      }
    }

    if (draftMessage.files != undefined) {
      const files: Array<ExtDraggableFile> = [];
      for (const file of draftMessage.files) {
        files.push({
          name: file.name,
          type: "existing",
          fileObject: undefined,
          url: file.url
        });
      }
      this.files = files;
    }

    this.isLoading = false;

    return;
  }

  public restoreFamilyTargets(restoreTargetMap: Map<string, string>): number {
    let restoredCount: number = 0;
    for (const targetGroup of this.targets) {
      for (const targetResident of targetGroup.residents) {
        for (let targetFamily of targetResident.families) {
          const sortKey: string | undefined = restoreTargetMap.get(targetFamily.residentsSortKey);

          if (sortKey != undefined) {
            targetFamily.isTarget = true;
            restoredCount++;
          } else {
            targetFamily.isTarget = false;
          }
        }
      }
    }
    return restoredCount;
  }

  public restoreOtherUserMemberTargets(restoreTargetMap: Map<string, string>): number {
    let restoredCount: number = 0;
    for (let group of this.otherUserTargets) {
      for (let member of group.members) {
        const sortKey: string | undefined = restoreTargetMap.get(member.otherUserGroupsSortKey);

        if (sortKey != undefined) {
          member.isTarget = true;
          restoredCount++;
        } else {
          member.isTarget = false;
        }
      }
    }
    return restoredCount;
  }

  public restoreSendMessageGroupTargetsAndGroupType(restoreTargetMap: Map<string, string>): number {
    let restoredCount: number = 0;
    for (let group of this.groupTargets.familyGroups) {
      const sortKey: string | undefined = restoreTargetMap.get(group.sendMessageGroupsSortKey);
      if (sortKey != undefined) {
        group.isTarget = true;
        this.groupType = GroupType.FAMILY;
        restoredCount++;
      } else {
        group.isTarget = false;
      }
    }
    for (let group of this.groupTargets.otherUserGroupMemberGroups) {
      const sortKey: string | undefined = restoreTargetMap.get(group.sendMessageGroupsSortKey);
      if (sortKey != undefined) {
        group.isTarget = true;
        this.groupType = GroupType.OTHER_USER;
        restoredCount++;
      } else {
        group.isTarget = false;
      }
    }
    for (let group of this.groupTargets.residentGroups) {
      const sortKey: string | undefined = restoreTargetMap.get(group.key);
      if (sortKey != undefined) {
        group.isTarget = true;
        this.groupType = GroupType.RESIDENT_GROUP;
        restoredCount++;
      } else {
        group.isTarget = false;
      }
    }
    for (let group of this.groupTargets.otherUserGroups) {
      const sortKey: string | undefined = restoreTargetMap.get(group.key);
      if (sortKey != undefined) {
        group.isTarget = true;
        this.groupType = GroupType.OTHER_USER_GROUP;
        restoredCount++;
      } else {
        group.isTarget = false;
      }
    }
    return restoredCount;
  }

  /**
   * ### S3に格納されているFileを取得する
   *
   * @param url 元URL
   */
  public async getS3File(url: string, fileName: string): Promise<File> {
    const response: File = await this.s3UrlService.getFile(userStore, Setting.backets.imageExpireHour, url, fileName);
    return response;
  }

  /**
   * メッセージ送信確認モーダルを表示する
   * 先にバリデーションチェックし、OKなら確認モーダルを表示する
   */
  public async sendMessageConfirm(): Promise<void> {
    this.isLoading = true;
    this.loadingMessage = "読込み中...";

    // チェック結果を初期化してからチェックしないと、エラーメッセージが残り続けてしまう
    this.$validator.errors.remove("type");
    this.$validator.errors.remove("message-targets");
    this.$validator.errors.remove("message-other-user-group-member-targets");
    this.$validator.errors.remove("message-group-targets");
    this.$validator.errors.remove("message-title");
    this.$validator.errors.remove("text");
    const validationResult: boolean = await this.$validator.validateAll();
    const fileValidationResult: boolean = this.validateFiles();
    // 宛先の必須チェックは個別で行う
    this.validMessageTargets();

    const _this: any = this;
    if (
      validationResult &&
      fileValidationResult &&
      !_this.errors.has("message-targets") &&
      !_this.errors.has("message-other-user-group-member-targets") &&
      !_this.errors.has("message-group-targets") &&
      !_this.errors.has("type")
    ) {
      this.showValidationAlert = false;
      const messageConfirmModal: SendMessageModal | Vue | Element | Vue[] | Element[] = this.$refs.messageConfirmModal;
      if (messageConfirmModal instanceof SendMessageModal) {
        const receivers: Array<LineReceiverDetail> = this.createMessagePreviewReceivers();
        const functionContents: SendMessageFunction = this.createMessagePreviewContents();
        messageConfirmModal.show(receivers, functionContents, true, this.type == "0" ? true : false);
      }
    } else {
      this.showValidationAlert = true;
    }

    this.isLoading = false;

    return;
  }

  /**
   * ### ファイルバリデーション
   *
   * - 何らかの原因でファイルが存在しないパターンがあったので、チェック処理を行う
   */
  public validateFiles(): boolean {
    for (const file of this.files) {
      if (!file || !file.name || (file.fileObject && file.fileObject.size == 0)) {
        this.$validator.errors.add({
          field: "tempfiles-multiple-register-errors",
          msg: `ファイルが破損等をしている可能性があり、ファイルを認識することができません。お手数ですが、再度選択し直してください。`
        });
        return false;
      }
    }
    return true;
  }

  /**
   * 送信時の宛先必須チェック
   */
  public validMessageTargets(): void {
    switch (this.type) {
      // 家族全員
      case "0": {
        // 家族数をカウントして、0件以下ならエラーとして扱う
        if (this.allFamily.length <= 0) {
          this.$validator.errors.add({ field: "type", msg: "利用者ご家族が登録されていないため、メッセージを送ることができません" });
        }
        break;
      }
      // 家族個別
      case "1": {
        // 送信対象をカウントして、0件以下ならエラーとして扱う
        let targetCount: number = 0;
        for (const targetGroup of this.targets) {
          for (const targetResident of targetGroup.residents) {
            for (const targetFamily of targetResident.families) {
              if (targetFamily.isTarget) {
                targetCount++;
              }
            }
          }
        }

        if (targetCount <= 0) {
          this.$validator.errors.add({ field: "message-targets", msg: "宛先は必須項目です" });
        }
        break;
      }
      // 施設関係者個別
      case "2": {
        // 送信対象をカウントして、0件以下ならエラーとして扱う
        let targetCount: number = 0;
        for (let target of this.otherUserTargets) {
          for (let targetMember of target.members) {
            if (targetMember.isTarget) {
              targetCount++;
            }
          }
        }

        if (targetCount <= 0) {
          this.$validator.errors.add({ field: "message-other-user-group-member-targets", msg: "宛先は必須項目です" });
        }
        break;
      }
      // 宛先グループ
      case "3": {
        // 送信対象をカウントして、0件以下ならエラーとして扱う
        let targetCount: number = 0;
        targetCount += this.countTarget(this.groupTargets.familyGroups);
        targetCount += this.countTarget(this.groupTargets.otherUserGroupMemberGroups);
        targetCount += this.countTarget(this.groupTargets.residentGroups);
        targetCount += this.countTarget(this.groupTargets.otherUserGroups);
        if (targetCount <= 0) {
          this.$validator.errors.add({ field: "message-group-targets", msg: "宛先は必須項目です" });
        }
        break;
      }
    }

    return;
  }

  private countTarget(items: Array<{ isTarget: boolean }>): number {
    let targetCount: number = 0;
    for (let target of items) {
      if (target.isTarget) {
        targetCount++;
      }
    }
    return targetCount;
  }

  /**
   * ### メッセージ送信プレビュー用の宛先リストを作成する
   */
  public createMessagePreviewReceivers(): Array<LineReceiverDetail> {
    // 宛先リストを作成する
    let receivers: Array<LineReceiverDetail> = [];
    switch (this.type) {
      // 全員送信
      case "0": {
        const receiver: LineReceiverDetail = {
          name: "家族全員",
          lineId: "",
          sortKey: "",
          room: "",
          residentName: "",
          residentKanaName: ""
        };
        receivers.push(receiver);
        break;
      }
      // 家族個別
      case "1": {
        for (const targetGroup of this.targets) {
          for (const targetResident of targetGroup.residents) {
            for (let targetFamily of targetResident.families) {
              if (targetFamily.isTarget) {
                const receiver: LineReceiverDetail = {
                  name: targetFamily.senderType == SenderType.MAIL ? targetFamily.familyName + "（メール）" : targetFamily.familyName,
                  lineId: "",
                  sortKey: "",
                  room: targetResident.room,
                  residentName: targetResident.name,
                  residentKanaName: targetResident.kanaName
                };
                receivers.push(receiver);
              }
            }
          }
        }
        break;
      }
      // 施設関係者個別
      case "2": {
        for (let group of this.otherUserTargets) {
          for (let member of group.members) {
            if (member.isTarget) {
              const receiver: LineReceiverDetail = {
                name: member.senderType == SenderType.MAIL ? member.memberName + "（メール）" : member.memberName,
                lineId: "",
                sortKey: "",
                room: "",
                residentName: "",
                residentKanaName: ""
              };
              receivers.push(receiver);
            }
          }
        }
        break;
      }
      // グループ
      case "3": {
        switch (this.groupType) {
          case GroupType.FAMILY: {
            receivers = receivers.concat(this.createReceiverDetailsForGroup(this.groupTargets.familyGroups));
            break;
          }
          case GroupType.OTHER_USER: {
            receivers = receivers.concat(this.createReceiverDetailsForGroup(this.groupTargets.otherUserGroupMemberGroups));
            break;
          }
          case GroupType.RESIDENT_GROUP: {
            receivers = receivers.concat(this.createReceiverDetailsForGroup(this.groupTargets.residentGroups));
            break;
          }
          case GroupType.OTHER_USER_GROUP: {
            receivers = receivers.concat(this.createReceiverDetailsForGroup(this.groupTargets.otherUserGroups));
            break;
          }
        }
        break;
      }
    }
    return receivers;
  }

  private createReceiverDetailsForGroup(items: Array<{ name: string; isTarget: boolean }>): Array<LineReceiverDetail> {
    const receivers: Array<LineReceiverDetail> = [];
    for (let group of items) {
      if (group.isTarget) {
        const receiver: LineReceiverDetail = {
          name: group.name,
          lineId: "",
          sortKey: "",
          room: "",
          residentName: "",
          residentKanaName: ""
        };
        receivers.push(receiver);
      }
    }
    return receivers;
  }

  public async emptyProsess(): Promise<void> {
    return new Promise((reject: Function) => {
      reject();
    });
  }

  public async getSendMessageGroupFamilyMembers(groupId: number): Promise<Array<SendMessageGroupMembersFamilyGetModel>> {
    const members: Array<SendMessageGroupMembersFamilyGetModel> = (await this.sendMessageGroupMembersService.get(
      userStore,
      groupId
    )) as Array<SendMessageGroupMembersFamilyGetModel>;
    return members;
  }

  public async getSendMessageGroupOtherGroupUserMembers(groupId: number): Promise<Array<SendMessageGroupMembersOtherUserGroupMemberGetModel>> {
    const members: Array<SendMessageGroupMembersOtherUserGroupMemberGetModel> = (await this.sendMessageGroupMembersService.get(
      userStore,
      groupId
    )) as Array<SendMessageGroupMembersOtherUserGroupMemberGetModel>;
    return members;
  }

  /**
   * ### メッセージ送信プレビュー用のコンテンツを作成する
   */
  public createMessagePreviewContents(): SendMessageFunction {
    // プレビュー表示するメッセージ内容
    const functionContents: SendMessageFunction = {
      title: this.title,
      content: this.text,
      addReadButton: this.addReadButton,
      addOptionText: this.addOptionText,
      addReplyButton: this.addReplyButton,
      replyLimit: userStore.facility.messageSettings.replyLimit
    };
    return functionContents;
  }

  /**
   * メッセージ送信確認ダイアログのOK処理
   */
  public async sendMessage(): Promise<void> {
    // async処理でPromiseメソッドを実行しないと画面表示が崩れるので空のPromiseメソッドを実行する
    await this.emptyProsess();

    // APIに渡すためのパラメータを作成する
    const lineTargetNames: string[] = [];
    const mailTargetNames: string[] = [];
    const lineSortKeys: Array<string> = [];
    const mailSortKeys: Array<string> = [];
    let messageType: string = this.type;
    let sendTarget: string = "";

    switch (this.type) {
      // 利用者家族全員
      case "0": {
        for (const targetFamily of this.allFamily) {
          if (targetFamily.senderType == SenderType.LINE && targetFamily.familyLineId) {
            lineSortKeys.push(targetFamily.residentsSortKey);
          } else if (targetFamily.senderType == SenderType.MAIL && targetFamily.familyMailaddress) {
            mailSortKeys.push(targetFamily.residentsSortKey);
          }
        }

        sendTarget = "family";
        lineTargetNames.push("家族全員");
        mailTargetNames.push("家族全員");
        break;
      }
      // 利用者家族個別
      case "1": {
        const lineFamilyNames: string[] = [];
        const mailFamilyNames: string[] = [];
        for (const targetGroup of this.targets) {
          for (const targetResident of targetGroup.residents) {
            for (const targetFamily of targetResident.families) {
              if (targetFamily.isTarget) {
                if (targetFamily.senderType == SenderType.LINE) {
                  lineSortKeys.push(targetFamily.residentsSortKey);
                  lineFamilyNames.push(targetFamily.familyName);
                } else {
                  mailSortKeys.push(targetFamily.residentsSortKey);
                  mailFamilyNames.push(targetFamily.familyName);
                }
              }
            }
          }
        }

        sendTarget = "family";
        lineTargetNames.push(lineFamilyNames.join("、"));
        mailTargetNames.push(mailFamilyNames.join("、"));
        break;
      }
      // 施設関係者個別
      case "2": {
        const lineMemberNames: string[] = [];
        const mailMemberNames: string[] = [];
        for (const group of this.otherUserTargets) {
          for (const member of group.members) {
            if (member.isTarget) {
              if (member.senderType == SenderType.LINE) {
                lineSortKeys.push(member.otherUserGroupsSortKey);
                lineMemberNames.push(member.memberName);
              } else {
                mailSortKeys.push(member.otherUserGroupsSortKey);
                mailMemberNames.push(member.memberName);
              }
            }
          }
        }

        sendTarget = "otherUser";
        lineTargetNames.push(lineMemberNames.join("、"));
        mailTargetNames.push(mailMemberNames.join("、"));
        break;
      }
      // グループ
      case "3": {
        const targetNames: string[] = [];

        switch (this.groupType) {
          case GroupType.FAMILY: {
            for (const group of this.groupTargets.familyGroups) {
              if (group.isTarget) {
                const members: Array<SendMessageGroupMembersFamilyGetModel> = await this.getSendMessageGroupFamilyMembers(group.id);
                // 送信用のLINEIDまたはメールアドレスを追加していく
                for (const member of members) {
                  if (member.senderType == SenderType.LINE && member.familyLineId) {
                    lineSortKeys.push(member.residentsSortKey as string);
                  } else if (member.senderType == SenderType.MAIL && member.familyMailaddress) {
                    mailSortKeys.push(member.residentsSortKey as string);
                  }
                }
                targetNames.push(group.name);
                sendTarget = "family";
              }
            }
            break;
          }
          case GroupType.OTHER_USER: {
            for (const group of this.groupTargets.otherUserGroupMemberGroups) {
              if (group.isTarget) {
                const members: Array<SendMessageGroupMembersOtherUserGroupMemberGetModel> = await this.getSendMessageGroupOtherGroupUserMembers(group.id);
                // 送信用のLINEIDまたはメールアドレスを追加していく
                for (const member of members) {
                  if (member.senderType == SenderType.LINE && member.memberLineId) {
                    lineSortKeys.push(member.otherUserGroupsSortKey as string);
                  } else if (member.senderType == SenderType.MAIL && member.memberMailaddress) {
                    mailSortKeys.push(member.otherUserGroupsSortKey as string);
                  }
                }
                targetNames.push(group.name);
                sendTarget = "otherUser";
              }
            }
            break;
          }
          case GroupType.RESIDENT_GROUP: {
            // 利用者グループにひもづく家族をMAPでまとめる
            const residentGroupMemberMap = new Map<number, Array<FamilyGetModel>>();
            for (const family of this.allFamily) {
              const families: Array<FamilyGetModel> | undefined = residentGroupMemberMap.get(family.groupId);
              if (families) {
                families.push(family);
                residentGroupMemberMap.set(family.groupId, families);
              } else {
                residentGroupMemberMap.set(family.groupId, [family]);
              }
            }

            for (const group of this.groupTargets.residentGroups) {
              if (group.isTarget) {
                // 送信用のLINEIDまたはメールアドレスを追加していく
                const members: Array<FamilyGetModel> | undefined = residentGroupMemberMap.get(group.id);
                if (!members) {
                  throw new SystemError("error residentGroup is not found");
                }
                for (const member of members) {
                  if (member.senderType == SenderType.LINE && member.familyLineId) {
                    lineSortKeys.push(member.residentsSortKey as string);
                  } else if (member.senderType == SenderType.MAIL && member.familyMailaddress) {
                    mailSortKeys.push(member.residentsSortKey as string);
                  }
                }

                targetNames.push(group.name);
                sendTarget = "family";
              }
            }
            messageType = "6";
            break;
          }
          case GroupType.OTHER_USER_GROUP: {
            // 施設関係者グループにひもづくメンバーをMAPでまとめる
            const otherUserGroupMemberMap = new Map<number, Array<OtherUserGroup>>();
            for (const member of this.otherUserGroupMembersInFacility) {
              const members: Array<OtherUserGroup> | undefined = otherUserGroupMemberMap.get(member.id);
              if (members) {
                members.push(member);
                otherUserGroupMemberMap.set(member.id, members);
              } else {
                otherUserGroupMemberMap.set(member.id, [member]);
              }
            }

            for (const group of this.groupTargets.otherUserGroups) {
              if (group.isTarget) {
                // 送信用のLINEIDまたはメールアドレスを追加していく
                const members: Array<OtherUserGroup> | undefined = otherUserGroupMemberMap.get(group.id);
                if (!members) {
                  throw new SystemError("error otherUserGroup is not found");
                }
                for (const member of members) {
                  if (member.senderType == SenderType.LINE && member.memberLineId) {
                    lineSortKeys.push(member.otherUserGroupsSortKey as string);
                  } else if (member.senderType == SenderType.MAIL && member.memberMailaddress) {
                    mailSortKeys.push(member.otherUserGroupsSortKey as string);
                  }
                }

                targetNames.push(group.name);
                sendTarget = "otherUser";
              }
            }
            messageType = "7";
            break;
          }
        }

        lineTargetNames.push(targetNames.join("、"));
        mailTargetNames.push(targetNames.join("、"));
        break;
      }
    }
    this.setScreenInputTemporaryStore();

    // LINE送信パラメータを作成する、送信先が無い場合はundefinedを格納する
    const sendLineMessage: SendLineMessagesPostModel = {
      sortKeys: lineSortKeys,
      targetName: lineTargetNames.join(),
      title: this.$stringUtil.convertYen(this.title),
      message: this.$stringUtil.convertYen(this.text),
      addOptionText: this.addOptionText,
      addReadButton: this.addReadButton,
      addReplyButton: this.addReplyButton,
      writerId: userStore.loginUser.userId,
      writtenBy: userStore.loginUser.name,
      fileUrls: [],
      fileNames: [],
      type: messageType
    };

    // メール送信パラメータを作成する、送信先が無い場合はundefinedを格納する
    const sendMailMessage: SendMailMessagesPostModel = {
      sortKeys: mailSortKeys,
      targetName: mailTargetNames.join(),
      subject: this.$stringUtil.convertYen(this.title),
      text: this.$stringUtil.convertYen(this.text),
      addOptionText: this.addOptionText,
      addReadButton: this.addReadButton,
      addReplyButton: this.addReplyButton,
      writerId: userStore.loginUser.userId,
      writtenBy: userStore.loginUser.name,
      fileUrls: [],
      fileNames: [],
      type: messageType,
      addReceivedMessageUrl: true,
      needDbRegister: true
    };

    this.$emit("send", {
      sendLineMessage: 0 < lineSortKeys.length ? sendLineMessage : undefined,
      sendMailMessage: 0 < mailSortKeys.length ? sendMailMessage : undefined,
      sendTarget: sendTarget,
      files: this.files,
      draftMessageId: this.draftMessageId
    });

    return;
  }

  /**
   * 宛先選択モーダルを表示する
   */
  public showSendTargetSelectModal() {
    // メモリ渡しだと値変更が共有されてしまう
    // 値変更後に「キャンセル」された場合に困るので、コピーしたものを渡す
    const copy: Array<SendMessageTargetGroup> = JSON.parse(JSON.stringify(this.targets));
    const modal: any = this.$refs.sendMessageSelectModal;
    modal.show(copy);
    return;
  }

  public showOtherUserGroupSelectModal() {
    // メモリ渡しだと値変更が共有されてしまう
    // 値変更後に「キャンセル」された場合に困るので、コピーしたものを渡す
    const copy: Array<OtherUserGroupTypeGroup> = JSON.parse(JSON.stringify(this.otherUserTargets));
    const modal: any = this.$refs.otherUserGroupSelectModal;
    modal.show(copy);
    return;
  }

  public showGroupSelectModal() {
    // メモリ渡しだと値変更が共有されてしまう
    // 値変更後に「キャンセル」された場合に困るので、コピーしたものを渡す
    const copy: GroupModel = JSON.parse(JSON.stringify(this.groupTargets));
    const modal: any = this.$refs.groupSelectModal;
    modal.show(copy);
    return;
  }

  /**
   * 宛先選択モーダルでOKボタンイベント処理
   */
  public addSendTarget(targets: Array<SendMessageTargetGroup>) {
    this.targets = targets;
    return;
  }

  /**
   * 宛先選択モーダルでOKボタンイベント処理
   */
  public addSendOtherUserGroupTarget(targets: Array<OtherUserGroupTypeGroup>) {
    this.otherUserTargets = targets;
    return;
  }

  /**
   * 宛先選択モーダルでOKボタンイベント処理
   */
  public addSendGroupTarget(targets: GroupModel) {
    this.groupTargets = targets;
    return;
  }

  /**
   * 個別の宛先のXボタンイベント処理
   */
  public deleteTarget(target: SendTargetFamily) {
    target.isTarget = false;
    return;
  }

  /**
   * 施設関係者に送信の宛先のXボタンイベント処理
   */
  public deleteOtherUserGroupTarget(target: OtherUserGroupTypeMember) {
    target.isTarget = false;
    return;
  }

  /**
   * 宛先グループに送信の宛先のXボタンイベント処理
   */
  public deleteGroupTarget(target: SendMessageGroupTargetModel) {
    target.isTarget = false;
    return;
  }

  /**
   * ## 見ましたのチェックボックス押下イベント
   *
   * - オプションテキストを強制的にfalseにする
   */
  public onAddReadCheck(): void {
    if (this.addReadButton == true) {
      this.addOptionText = false;
    }
    return;
  }

  public getSenderType(senderType: SenderType): string {
    if (senderType == SenderType.MAIL) {
      return "（メール）";
    } else {
      return "";
    }
  }

  /**
   * ### 画面入力情報をstoreから復元し、store情報を初期化する
   */
  public restoreScreenInputTemporaryStore(): void {
    if (screenInputTemporaryStore.url == PcUrl.SendMessage) {
      this.type = screenInputTemporaryStore.inputParams.type;
      this.targets = screenInputTemporaryStore.inputParams.targets;
      this.otherUserTargets = screenInputTemporaryStore.inputParams.otherUserTargets;
      this.groupTargets = screenInputTemporaryStore.inputParams.groupTargets;
      // 復元するとタイトルと本文が上書きされるので復元しない
      // this.templateId = screenInputTemporaryStore.inputParams.templateId;
      this.title = screenInputTemporaryStore.inputParams.title;
      this.text = screenInputTemporaryStore.inputParams.text;
      this.addOptionText = screenInputTemporaryStore.inputParams.addOptionText;
      this.addReadButton = screenInputTemporaryStore.inputParams.addReadButton;
      this.addReplyButton = screenInputTemporaryStore.inputParams.addReplyButton;
      this.files = screenInputTemporaryStore.inputParams.files;
      this.draftMessageId = screenInputTemporaryStore.inputParams.draftMessageId;
      this.draftMessageOldFiles = screenInputTemporaryStore.inputParams.draftMessageOldFiles;
      this.draftMessageUpdated = screenInputTemporaryStore.inputParams.draftMessageUpdated;
      this.needConvertPdf = screenInputTemporaryStore.inputParams.needConvertPdf;

      this.resetScreenInputTemporaryStore();
    }
    return;
  }

  /**
   * ### 画面入力情報のstoreをリセットする
   */
  public resetScreenInputTemporaryStore(): void {
    screenInputTemporaryStore.initializeScreenInputTemporary();
    return;
  }

  /**
   * ### 画面入力情報をstoreに格納する
   *
   * - 一時間無操作タイムアウト対策としてAPIリクエスト前にstoreに保存する
   */
  public setScreenInputTemporaryStore(): void {
    screenInputTemporaryStore.setScreenInputTemporary({
      url: PcUrl.SendMessage,
      inputParams: {
        type: this.type,
        targets: this.targets,
        otherUserTargets: this.otherUserTargets,
        groupTargets: this.groupTargets,
        templateId: this.templateId,
        title: this.title,
        text: this.text,
        addOptionText: this.addOptionText,
        addReadButton: this.addReadButton,
        addReplyButton: this.addReplyButton,
        files: this.files,
        existFile: 0 < this.files.length ? true : false,
        draftMessageId: this.draftMessageId,
        draftMessageOldFiles: this.draftMessageOldFiles,
        draftMessageUpdated: this.draftMessageUpdated,
        needConvertPdf: this.needConvertPdf
      }
    });
    return;
  }

  /**
   * ### vue lifecycle activated
   */
  public async activated(): Promise<void> {
    this.$validator.errors.clear();
    this.showValidationAlert = false;

    if (needRefreshesStore.sendMessage.sendMessages == true) {
      await this.initilizeTemplate();
      await this.createView();
      needRefreshesStore.sendMessage.sendMessages = false;
    }
    return;
  }

  /**
   * ### 登録可能なファイル数を返す
   */
  get _registerImageFilesLimit(): number {
    const limit: number = this.registerFileUploadLimit - this.files.length;
    return limit;
  }

  get _enablePreviewStatus(): boolean {
    return 0 < this.files.length ? true : false;
  }

  async deactivated() {
    await this.$validator.reset();
    this.$validator.errors.clear();
    this.showValidationAlert = false;
    return;
  }
}

export interface GroupModel {
  familyGroups: Array<SendMessageGroupTargetModel>;
  otherUserGroupMemberGroups: Array<SendMessageGroupTargetModel>;
  residentGroups: Array<ResidentGroupTargetModel>;
  otherUserGroups: Array<OtherUserGroupTargetModel>;
}
export interface SendMessageGroupTargetModel extends SendMessageGroupsGetModel {
  /** モーダルの表示可否 */
  show: boolean;
  /** 宛先対象か否か */
  isTarget: boolean;
  /** グループメンバー数 */
  memberCount: number;
}
export interface ResidentGroupTargetModel extends ResidentGroupsGetModel {
  /** モーダルの表示可否 */
  show: boolean;
  /** 宛先対象か否か */
  isTarget: boolean;
  /** グループメンバー数 */
  memberCount: number;
  /** key */
  key: string;
}
export interface OtherUserGroupTargetModel extends OtherUserGroup {
  /** モーダルの表示可否 */
  show: boolean;
  /** 宛先対象か否か */
  isTarget: boolean;
  /** グループメンバー数 */
  memberCount: number;
  /** key */
  key: string;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.send-message-form {
  .right-side {
    margin-left: auto;
  }

  .send-message-btn {
    width: 104px;
  }
  .send-targets {
    max-width: 600px;

    .send-target-select-btn {
      margin: 0 8px 4px 0;
    }
    .send-target {
      display: inline-block;
      padding: 7px;
      @include font(16px);
      margin: 0 8px 4px 0;
      border-radius: 3px;
      transition: all 0.2s;
      border: 1px solid $form-border-color;

      .target-name {
        margin: 0 8px 0 0 !important;
      }
      .delete-btn {
        margin: 0 !important;
        font-size: 14px !important;
      }
    }
  }
  #message-title {
    max-width: 600px;
    width: 600px;
  }
  #text {
    max-width: 600px;
    width: 600px;
  }
  // テキスト入力領域はリサイズできてしまうとレイアウトが崩れるためリサイズを不可にする
  textarea {
    resize: none;
  }

  // チェックボックスは横一列に並べる
  .checkboxs {
    .option-text {
      width: 240px !important;
      margin-right: 40px;
      border-right: 1px solid $form-border-color;
    }
    .register-row {
      width: 180px;
    }
    .option-button {
      margin-bottom: 10px !important;
    }
  }

  .need-convert-pdf {
    margin: 8px 0 8px 0;

    // 画像でセレクトボックスを表現するので、input要素自体は非表示にする
    input[type="checkbox"] {
      display: none;

      // input要素の代わりに画像つきのspanにする
      // 選択しているか否かで画像を切り替える
      // for属性でcheckboxと紐づかせたspan要素のclickで、チェックボックスの状態が変更される
      & + span {
        // チェックボックス画像が全て表示されるように高さを指定する
        height: 46px;
        // チェックボックス画像が文字より大きく、文字が縦中央揃えに出来ないので、paddingで上下余白を取って位置調整
        padding: 6px 0 0 40px;
        background: url("../../../assets/login-checkbox-off.png") no-repeat left center;
        // チェックボックス画像のサイズを指定
        // 正方形なので要素の高さと同じになる
        background-size: 32px 32px;
      }
      &:checked + span {
        background: url("../../../assets/login-checkbox-on.png") no-repeat left center;
        // チェックボックス画像のサイズを指定
        // 正方形なので要素の高さと同じになる
        background-size: 32px 32px;
      }
    }
    .text {
      margin: 0 !important;
    }
  }

  .box-footer {
    padding: 10px 0 0 0 !important;
  }

  // ボタン位置をテキスト入力領域に合わせる
  .register-footer {
    @media (max-width: 1540px) {
      // 添付ファイルが縦に回り込んだときはボタンの位置を入力コンテンツの右端と同じにする
      .buttons {
        max-width: 605px;
      }
    }
  }
}
</style>
